export default __webpack_public_path__ + "static/media/login2.4d13f1b7.png";